import { Controller } from "@hotwired/stimulus"

// Widget domanda interattiva: in "single" un click invia subito la risposta
// nel form chat; in "multiple" le opzioni si accumulano e si invia col bottone.
// "Altro" mette il focus sulla textarea per una risposta libera.
export default class extends Controller {
  static targets = ["option", "submit"]
  static values = { kind: String }

  pick(event) {
    const button = event.currentTarget
    if (this.kindValue === "multiple") {
      button.dataset.selected = button.dataset.selected === "true" ? "false" : "true"
      const any = this.optionTargets.some((option) => option.dataset.selected === "true")
      if (this.hasSubmitTarget) this.submitTarget.classList.toggle("hidden", !any)
      return
    }
    this.#submit(event.params.label)
  }

  send() {
    const labels = this.optionTargets
      .filter((option) => option.dataset.selected === "true")
      .map((option) => option.dataset.questionReplyLabelParam)
    if (labels.length > 0) this.#submit(labels.join(", "))
  }

  other() {
    document.querySelector("#proposal_chat_form textarea")?.focus()
  }

  #submit(text) {
    const input = document.querySelector("#proposal_chat_form textarea")
    const form = input?.closest("form")
    if (!input || !form) return
    input.value = text
    form.requestSubmit()
  }
}
